<template>
  <div class="home">
      <div class="header">
          <headerShow></headerShow>
      </div>
      <div class="homeBody">
          <div class="selectOptionAll">
            <div class="selectOption">
              <div class="selectTitle text-justify">
                赛道
              </div>
              <div class="optionItems">
                <Tag checkable color="primary" :checked="tagCheckAll" @on-change="toggleCheckAllFN">全部</Tag>
                <Tag checkable color="primary" :checked="item.checked" :name="JSON.stringify(item)" v-for="(item,index) in tagArr" @on-change="toggleFN" :key="index">{{item.desc}}</Tag>
              </div>
            </div>
          </div>
          <div class="detailContent">
                <div class="searchClass">
                     <Input prefix="ios-search" v-model="queryModel" :placeholder="模糊搜索" style="width: auto" />
                    <div class="selectOption marginClass">
                        <Button type="info" icon="ios-search" @click="submitQuery">{{$t("queryVal")}}</Button>
                    </div>
                </div>
                <div class="resultContent">
                    <div class="resultInnerItem" v-for="(item,indexs) in resultList" :key="indexs" @click="goPatternPage(item.id)">
                        <div  class="resultItem" :style="{backgroundImage:'url('+ item.cover + ')'}"></div>
                        <div class="resultTitle">{{item.name}}</div>
                        <div class="resultTitle">{{item.creater}}</div>
                    </div>
                    <div class="resultMark"></div>
                    <div class="resultMark"></div>
                    <div class="resultMark"></div>
                    <div class="resultMark"></div>
                    <div class="resultMark"></div>
                    <div class="resultMark"></div>
                </div>
                <div class="resultPage">
                    <Page :current="currentPage" :total="totalPageNum" @on-change="changePageFN" :page-size="pageSizeVal" size="small" show-total />
                </div>
          </div>
      </div>
      <footerView></footerView>
  </div>
</template>

<script>
import headerShow from '@/components/headerShow.vue'
import footerView from '@/components/footer.vue'
import { matchListRequest } from '../request/request'
export default {
  name: 'detail',
  components: {
    headerShow, footerView
    // swiper
  },
  data () {
    return {
      pageSizeVal: 20,
      languageVal: 'ch',
      queryModel: '',
      tabModel: 'name1',
      tagCheckAll: true,
      tagArr: [{ checked: false, desc: 'MINI电影', descEn: 'MINI电影', title: 'MINI电影' }, { checked: false, desc: '视频广告', descEn: '视频广告', title: '视频广告' }, { checked: false, desc: 'AI影像', descEn: 'AI影像', title: 'AI影像' }],
      tagCheckAll_1: false,
      tagArr_1: [{ checked: true, desc: '中国', title: 'place', descEn: 'China' }, { checked: false, desc: '日韩', title: 'place', descEn: 'Japan and South Korea' }, { checked: false, desc: '欧洲', title: 'place', descEn: 'Europe' }, { checked: false, desc: '美洲', title: 'place', descEn: 'America' }, { checked: false, desc: '其它', title: 'place', descEn: 'Others' }],
      tagCheckAll_2: false,
      tagArr_2: [],
      tagCheckAll_3: false,
      tagArr_3: [],
      page: localStorage.detailPage ? localStorage.detailPage : '1',
      totalPageNum: 0,
      resultList: [],
      dataObj: {},
      currentPage: 1

    }
  },
  computed: {

  },
  mounted () {
    this.languageVal = localStorage.getItem('language') === 'en' ? 'en' : 'ch'
  },
  created () {
    this.$nextTick(() => {
      this.initFN()
      document.scrollingElement.scrollTop = 0
    })
  },
  methods: {    
    async detailRequestFN (e) {
      var res = await matchListRequest(e)
      if (res.data.code === 0) {
        console.log(res.data)
        this.totalPageNum = res.data.data.totalNumber
        this.resultList = res.data.data.list
      }
    },    
    
    changePageFN (e) {
      localStorage.detailPage = e
      this.page = e
      this.dataObj.pageNum = e
      this.detailRequestFN(this.dataObj)
    },

    changeModeFN (e) {
      this.dataObj.tab = e === 'name1' ? '1' : '2'
      this.detailRequestFN(this.dataObj)
    },
    
    submitQuery () {
      var indexMark
      var tagArrStr = []
      this.tagArr.forEach((e, index) => {
        if (e.checked) {
          indexMark = index
          tagArrStr.push(indexMark)
        }
      })
      this.dataObj = {
        pageNum: this.page,
        title: this.queryModel,
        categorys: tagArrStr,
      }
      this.detailRequestFN(this.dataObj)
    },

    gotoPage (e) {
      window.open(e)
    },

    initFN () {
      this.submitQuery()
    },
    
    goPatternPage (e) {
      this.$router.push({
        path: '/matchDetail',
        name: 'matchDetail',
        query: {
          id: e
        }
      })
    },

    toggleCheckAllFN (e) {
      this.tagArr.map(item => {
        item.checked = e
        return item
      })
      this.submitQuery()
    },

    toggleFN (e, value) {
      let tagObj = JSON.parse(value)
      this.tagArr.map(item => {
        if (tagObj.desc == item.desc) {
          item.checked = e
        }
        return item
      })
      let checkAllMark = 0
      this.tagArr.map(item => {
        if (!item.checked) {
          checkAllMark = 1
        }
      })
      if (checkAllMark === 1) {
        this.tagCheckAll = false
      } else {
        this.tagCheckAll = true
      }
      this.submitQuery()
    },

  }
}
</script>
<style lang="scss">
.resultItem{
    cursor: pointer;
}
.resultPage{
    margin: 15px 0;
    @include bottomLine
}
.marginClass{
    margin-left: 15px;
}
.resultMark{
width:15.6vw;
min-width:160px;
}
.resultTitle{
    display: block;
    width:15.6vw;
    height: 5vh;
    min-height: 20px;
    font-size: 12px;
    // @include centerLine;
    align-items: flex-start;
    text-align: center;
    font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.resultItem{
    @include fullbackground;
    margin-bottom: 1vh;
    width:15.6vw;
    height: 8.84vw;
    min-width:160px;
    min-height: 90.6px;
    // background-image: url('../assets/1.png');

}
.resultContent{
    width: 100%;
    min-height: 30vh;
    @include startLine;
    justify-content:space-around;
    flex-wrap: wrap;
    margin-top:3vh;
    background: white;
    padding-top: 2vh;
}
.searchClass{
    margin: 10px 0;
    width: 100%;
    @include startLine
}
.ivu-tag{
    cursor:pointer
}
.selectOptionAll{
    width: 90%;
    margin:0 auto;
    margin-top: 15px;
    .selectTitle{
        width: 8vw;
        // @include betweenLine;
        min-width: 80px;
        font-size: 16px;
        margin-right: 5vw;
        font-weight: bold;
        // align-items:flex-start;
    }
    .selectOption{
        @include startLine;
        align-items:flex-start;
        flex-wrap: nowrap;
        .optionItems{
            @include startLine;
            flex-wrap: wrap;
        }
    }
}
.detailContent{
    width: 90%;
    margin:0 auto;
}
.home{
    width:100%;
    .header{
      background: #ffffff;
      height: 7vh;
      min-height: 60px;
      padding: 0 0px;
      @include betweenLine;
      color: white;
    }

    .homeBody{
        width: 100%;
        min-height: 75vh;

    }
    .homeBottom{
        width:100%;
        .partnerList{
            font-size: 4vh;
            width: 100%;
            @include centerLine;
            flex-direction: column;
            .partneListTitle{
                margin-top: 3vh;
                margin-bottom:3vh;
                border-bottom:2px solid #2E6DAD
            }
            .partnerListContent{
                @include startLine;
                justify-content: center;
                flex-wrap: wrap;
                width:80%;
                margin: 0 auto;
            }
        }
    }
    .ivu-modal-header{
        background: #2E6DAD
    }
}

</style>
